const config = {
  apiAddress: "https://murmuring-dawn-33028-976437b7fe94.herokuapp.com/api/",
};

export default config;
